import Axios from "axios";
import { SET_INV_STOCK_REPORT, UNSET_INV_STOCK_REPORT } from "@/store/mutation-types";
import { getInvStockReport } from "@/store/api";

const state = {
  getInvStockReport: [],
};

const getters = {
  getInvStockReport(state) {
    return state.getInvStockReport;
  },
};

const mutations = {
  [SET_INV_STOCK_REPORT](state, data) {
    state.getInvStockReport = data;
  },
  [UNSET_INV_STOCK_REPORT](state) {
    state.getInvStockReport = [];
  },
};

const actions = {
  getInvStockReport({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(getInvStockReport, {params: data})
        .then(function (response) {
          commit("SET_INV_STOCK_REPORT", response.data.data);
          resolve(response);
        })
        .catch(function (error) {
          commit("UNSET_INV_STOCK_REPORT");
          reject(error);
        })
        .then((always) => {});
    });
  },
};

export default { state, getters, actions, mutations };
